import loadable from '@loadable/component';

export const ApiAccessContainerLoadable = loadable(
  () => import('./ApiAccessContainer'),
  {
    resolveComponent: (module) => module.ApiAccessContainer,
  },
);
